import {
    type DeleteEventResponseType,
    type DeleteEventRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteEvent = async (params: DeleteEventRequestType): Promise<DeleteEventResponseType> => {
    return await request<DeleteEventResponseType>(`/events/deleteEvent?eventID=${params.eventID}`, {
        method: "DELETE"
    });
};

export default DeleteEvent;
